import { SiteType, TeamContext } from "../types/common";

export const getTeamNameByCode = (team: TeamContext): string => {
    switch (team) {
        case TeamContext.RODINA:
            return 'Родина';
        case TeamContext.ACADEMY:
            return 'Академия';
        case TeamContext.RODINA_2:
            return 'Родина-2';
        case TeamContext.RODINA_3:
            return 'Родина-М';
        case TeamContext.RODINA_M:
            return 'Молодёжка';
        default:
            return 'Родина';
    }
}

export const getTeamIdByCode = (teamCode: TeamContext) => {
    switch (teamCode) {
        case TeamContext.RODINA:
            return 3;
        case TeamContext.RODINA_2:
            return 135;
        case TeamContext.RODINA_3:
            return 724;
        case TeamContext.ACADEMY:
            return 3;
        case TeamContext.RODINA_M:
            return 204;
        default:
            return 3;
    }
}

export const getSiteByTeamCode = (teamCode: TeamContext) => {
    switch (teamCode) {
        case TeamContext.ACADEMY:
        case TeamContext.RODINA_M:
            return SiteType.LEGACY_ACADEMY;
        case TeamContext.RODINA:
        case TeamContext.RODINA_2:
        case TeamContext.RODINA_3:
        default:
            return SiteType.LEGACY_RODINA;
    }
}